var BreadCrumbModel;

module.exports = BreadCrumbModel = (function() {
  function BreadCrumbModel(arg) {
    this.title = arg.title, this.friendlyName = arg.friendlyName, this.id = arg.id, this.href = arg.href, this.showSeparator = arg.showSeparator, this.showHref = arg.showHref;
    if (this.showHref == null) {
      this.showHref = true;
    }
    if (this.showSeparator == null) {
      this.showSeparator = true;
    }
  }

  BreadCrumbModel.prototype.getTitle = function() {
    var ref;
    return (ref = this.title) != null ? ref : this.friendlyName;
  };

  return BreadCrumbModel;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icmVhZGNydW1iL2NvbW1vbi9tb2RlbHMvY3J1bWIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icmVhZGNydW1iL2NvbW1vbi9tb2RlbHMvY3J1bWIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBdUI7RUFDUix5QkFBQyxHQUFEO0lBQUUsSUFBQyxDQUFBLFlBQUEsT0FBTyxJQUFDLENBQUEsbUJBQUEsY0FBYyxJQUFDLENBQUEsU0FBQSxJQUFJLElBQUMsQ0FBQSxXQUFBLE1BQU0sSUFBQyxDQUFBLG9CQUFBLGVBQWUsSUFBQyxDQUFBLGVBQUE7O01BQ2pFLElBQUMsQ0FBQSxXQUFZOzs7TUFDYixJQUFDLENBQUEsZ0JBQWlCOztFQUZQOzs0QkFJYixRQUFBLEdBQVUsU0FBQTtBQUNSLFFBQUE7OENBQVMsSUFBQyxDQUFBO0VBREYifQ==
